import { render, staticRenderFns } from "./RedaIcon.vue?vue&type=template&id=65a91e8a&scoped=true"
import script from "./RedaIcon.vue?vue&type=script&lang=js"
export * from "./RedaIcon.vue?vue&type=script&lang=js"
import style0 from "./RedaIcon.vue?vue&type=style&index=0&id=65a91e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a91e8a",
  null
  
)

export default component.exports